import { FunctionComponent, useEffect, useState } from 'react';
import { Grid, CircularProgress } from '@material-ui/core';
import { useStyles } from './price-box.styles';

interface IPriceBoxPackageDetails {
    monthlyPrice: number;
    yearlyPrice: number;
    productDiscountPct: number;
}

interface IPriceBoxProps {
    labels: { discountText: string; monthLabel: string; yearLabel: string };
    packagesDetails: IPriceBoxPackageDetails;
    isPackagePriceLoading: boolean;
}

interface IPriceBoxState {
    monthlyPriceStr: string;
    yearlyPriceStr: string;
    hasDiscount: boolean;
    productDiscountPctStr: string;
}

const PriceBox: FunctionComponent<IPriceBoxProps> = (props): JSX.Element => {
    const classes = useStyles();
    const { labels, packagesDetails, isPackagePriceLoading } = props;
    const [selectedPackageInfo, setSelectedPackageInfo] = useState<IPriceBoxState>({
        monthlyPriceStr: '',
        yearlyPriceStr: '',
        hasDiscount: false,
        productDiscountPctStr: '',
    });

    useEffect(() => {
        const state: IPriceBoxState = {
            monthlyPriceStr: packagesDetails.monthlyPrice.toString(),
            yearlyPriceStr: packagesDetails.yearlyPrice.toString(),
            hasDiscount: packagesDetails.productDiscountPct !== 0,
            productDiscountPctStr: packagesDetails.productDiscountPct.toString(),
        };
        setSelectedPackageInfo(state);
    }, [packagesDetails]);

    return (
        <div className={classes.priceMain}>
            <section>
                <Grid item xs={12}>
                    {isPackagePriceLoading && <CircularProgress size={50} />}
                    <div className={isPackagePriceLoading ? classes.gridItemLoading : classes.gridItem}>
                        <div className={classes.totalPriceInfo}>
                            <div className={classes.totalPriceMonthly}>
                                {selectedPackageInfo.monthlyPriceStr}
                                <small className={classes.small}> {labels.monthLabel}</small>
                            </div>
                        </div>

                        {selectedPackageInfo.hasDiscount && (
                            <div className={classes.discountPriceInfo}>
                                {labels.discountText.replace(
                                    '###percent###',
                                    selectedPackageInfo.productDiscountPctStr
                                )}
                            </div>
                        )}

                        {!selectedPackageInfo.hasDiscount && (
                            <div className={classes.totalPriceYearly}>
                                {selectedPackageInfo.yearlyPriceStr} {labels.yearLabel}
                            </div>
                        )}
                    </div>
                </Grid>
            </section>
        </div>
    );
};

export { PriceBox };
export type { IPriceBoxProps, IPriceBoxPackageDetails };
